import React, { useEffect, Fragment } from 'react';
import InfoSlide from './../components/InfoSlide';
import OptionSlide from './../components/OptionSlide';
import { useNavigate, useParams } from 'react-router-dom';
import useInteractiveSlug from '../hooks/useInteractiveSlug';

const Slide = (props) => {
  const { index, slideIndex, selectedIndex, type } = props;
  const { url } = useInteractiveSlug();
  const params = useParams();
  const navigate = useNavigate();

  // Calculate this during render, not in state!
  const isActive = index === selectedIndex;

  // Handle navigation in one effect only when THIS slide is the chosen one.
  // Guard params.person: when navigating away from slides (e.g. "All Stories"),
  // the URL clears before slides unmount, which would write "undefined" into the URL.
  useEffect(() => {
    if (isActive && params.person) {
      navigate(`${url}/${params.person}/${index + 1}`);
    }
  }, [isActive, index, navigate, url, params.person]);

  return (
    <Fragment>
      {type === 'decision' ? (
        <OptionSlide {...props} isActive={isActive} activeNumber={slideIndex} />
      ) : (
        <InfoSlide {...props} isActive={isActive} activeNumber={slideIndex} />
      )}
    </Fragment>
  );
};

export default Slide;
